'use strict';

/**
 * Exhibitions
 */
waApp.controllers.Exhibitions = {
	add: function() {
		waUtils.inputLanguageToggle();
	},
	edit: function() {
		waUtils.inputLanguageToggle();
	}
};
